import { render, staticRenderFns } from "./rule-field-name.vue?vue&type=template&id=9621a51a&scoped=true&"
import script from "./rule-field-name.vue?vue&type=script&lang=js&"
export * from "./rule-field-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9621a51a",
  null
  
)

export default component.exports